import { type JanusCtx, type Row, insertRoll, itemField, upper } from '../context.js';
import { type JanusInput } from '../janus.js';
import { isPaoeEntry } from '../paoe-entry-mode.js';
import { postEffectConditions } from '../post-effect-conditions.js';
import { effectTargets } from '../is-target-valid-for-effect.js';

/** CENSUS ONLY (tools/test/janus-ability-oracle-census.mjs): replay legacy's SHARED gate to rule a per-target divergence exactly. No page
 *  code sets this. */
export const noRollLegacyReplay = { sharedGate: false };
/** includes/functions/janus/rolls/no_roll.php:no_roll */
export function noRoll(ctx: JanusCtx, input: JanusInput, ability: Row, caster: Row, targets: Row[]): void {
  // Wizard v9 Grim Harvest (summon.ts fireCorpseUse): the cast went off (a persistent-area spell reaches noRoll without the dispatcher)
  if (!ctx.trigger && targets.length) ctx.castsWentOff = (ctx.castsWentOff ?? 0) + 1;
  const eligible = effectTargets(ctx, input, ability, caster, targets);
  if (!eligible) return;
  // OWNER RULING 2026-10-08 (lane A15): no-roll post-effect conditions are judged PER TARGET. Legacy janus.php shares one by-reference
  // `$post_effect_conditions_met` slot that no_roll never resets (the first processed target's verdict reached every later target) — a
  // census-ruled divergence (`no-roll-post-effect-per-target`), no longer parity.
  let sharedGate: boolean | undefined;
  for (const target of eligible) {
    // no_roll.php: a zone-entry re-resolution onto a target already holding the ability as a status logs nothing (the duplicate no-ops).
    const redundant = isPaoeEntry(input) && /^[0-9A-F-]{36}$/i.test(input.abilityId)
      && ctx.read.statuses(target).some((status) => upper(status.status_item_id) === upper(input.abilityId));
    if (!redundant)
      insertRoll(ctx, { roll_type_1: 'no_roll', roll_type_2: input.consumeInventoryUnit ? 'consume' : String(itemField(ability, 'item_type') ?? ''), roll_item_id: input.abilityId, by: caster, to: target });
    const met = postEffectConditions(ctx, input, ability, caster, target, false, noRollLegacyReplay.sharedGate ? sharedGate : undefined);
    if (noRollLegacyReplay.sharedGate) sharedGate = met;
  }
}
